import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Layout } from "antd";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import Logo from "./Logo";
import NavPanel from "./NavPanel";
import { toggleCollapsedNav, onMobileNavToggle } from "redux/actions/Theme";
import {
  NAV_TYPE_TOP,
  SIDE_NAV_COLLAPSED_WIDTH,
  SIDE_NAV_WIDTH,
} from "constants/ThemeConstant";
import utils from "utils";
import NavNotification from "./NavNotification";
import MyAccount from "components/reusable-components/My-Account";
import { useDispatch, useSelector } from "react-redux";
import {
  getByIdUserDetailData,
  getByIdUserDetailsRequest,
} from "redux/reducers/manageUser";
import { socketlist } from "redux/reducers/socket";
import SupportWidget from "components/shared-components/SupportWidget/SupportWidget";

const { Header } = Layout;

export const HeaderNav = (props) => {
  const {
    navCollapsed,
    mobileNav,
    navType,
    headerNavColor,
    toggleCollapsedNav,
    onMobileNavToggle,
    isMobile,
    currentTheme,
    direction,
  } = props;

  const onToggle = () => {
    if (!isMobile) {
      toggleCollapsedNav(!navCollapsed);
    } else {
      onMobileNavToggle(!mobileNav);
    }
  };

  const isNavTop = navType === NAV_TYPE_TOP ? true : false;
  const mode = () => {
    if (!headerNavColor) {
      return utils.getColorContrast(
        currentTheme === "dark" ? "#00000" : "#ffffff"
      );
    }
    return utils.getColorContrast(headerNavColor);
  };
  const navMode = mode();
  const getNavWidth = () => {
    if (isNavTop || isMobile) {
      return "0px";
    }
    if (navCollapsed) {
      return `${SIDE_NAV_COLLAPSED_WIDTH}px`;
    } else {
      return `${SIDE_NAV_WIDTH}px`;
    }
  };

  const [userData, setUserData] = useState();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getByIdUserDetailsRequest({ id: localStorage.getItem("user") }));
  }, []);

  const getUserData = useSelector(getByIdUserDetailData);
  const socket = useSelector(socketlist);
  useEffect(() => {
    setUserData(getUserData?.data?.data);
    const parentPaths = [
      ...new Set(
        getUserData?.data?.data.accessPath
          .map((asset) => {
            const parts = asset.parentPath.split("/");
            return parts.find((part) => part.startsWith("ORG")); //[1]
          })
          .filter(Boolean)
      ),
    ];
    if (parentPaths.length > 0) {
      socket.emit("addUser", {
        parentPaths: parentPaths,
      });
    }
  }, [getUserData]);

  const hasAccess = (userRoles = [], requiredRoles = []) => {
    return userRoles.some((role) => requiredRoles.includes(role.code));
  };

  return (
    <Header
      className={`app-header ${navMode}`}
      style={{ backgroundColor: headerNavColor }}
    >
      <div className={`app-header-wrapper ${isNavTop ? "layout-top-nav" : ""}`}>
        <div className="nav" style={{ width: `calc(100% - ${getNavWidth()})` }}>
          <div className="nav-left">
            <ul className="ant-menu ant-menu-root ant-menu-horizontal">
              {isNavTop && !isMobile ? null : (
                <li
                  className="ant-menu-item ant-menu-item-only-child"
                  onClick={() => {
                    onToggle();
                  }}
                >
                  {navCollapsed || isMobile ? (
                    <MenuUnfoldOutlined className="nav-icon" />
                  ) : (
                    <MenuFoldOutlined className="nav-icon" />
                  )}
                </li>
              )}
            </ul>
            <Logo
              logoType={navMode}
              headerImagesResponseData={props.headerImagesResponse}
            />
          </div>
        </div>
        <div className="nav-right">
          {hasAccess(userData?.roles ?? [], [
            "VIGADMIN",
            "PLATFORM_ADMIN",
            "SYSTEM_ADMIN",
            "FT_ADMIN",
          ]) && (
            <SupportWidget
              apiKey={process.env.REACT_APP_API_KEY}
              apiUrl={process.env.REACT_APP_API_URL}
              appCode={process.env.REACT_APP_APP_CODE}
              userEmail={userData?.email ?? ""}
              userName={userData?.name ?? ""}
              companyName="Jetatech"
            />
          )}
          <NavNotification />
          <MyAccount data={userData} />
          <NavPanel direction={direction} />
        </div>
      </div>
    </Header>
  );
};

const mapStateToProps = ({ theme }) => {
  const {
    navCollapsed,
    navType,
    headerNavColor,
    mobileNav,
    currentTheme,
    direction,
  } = theme;
  return {
    navCollapsed,
    navType,
    headerNavColor,
    mobileNav,
    currentTheme,
    direction,
  };
};

export default connect(mapStateToProps, {
  toggleCollapsedNav,
  onMobileNavToggle,
})(HeaderNav);
